<sc-padding>
  <sc-label labelDictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.case-company-title"></sc-label>
  <div>{{ gateKeepingCandidate?.company }}</div>
  <sc-label labelDictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.case-name-title"></sc-label>
  <div>{{ gateKeepingCandidate?.name }}</div>
  <sc-label labelDictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.case-numberplate-title"></sc-label>
  <div>{{ gateKeepingCandidate?.numberPlate }}</div>
  <sc-label labelDictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.case-hint-title"></sc-label>
  <div>{{ gateKeepingCandidate?.hint }}</div>
</sc-padding>
